import { createGlobalStyle, css } from 'styled-components';
import { darken, normalize } from 'polished';
// import * as fonts from '../assets/fonts/roboto'; // Removed as unused

// https://github.com/styled-components/awesome-styled-components
// https://blog.cloudboost.io/separate-your-code-with-styled-components-ec4fd1ee3ef8
// https://medium.com/@pitipatdop/10-useful-tips-for-styled-components-b7710b021e6a
// https://github.com/withspectrum/spectrum/tree/alpha/src/components
// https://medium.com/tech-tajawal/react-styled-components-79e94f771732
// https://stackoverflow.com/questions/48975311/style-an-imported-styled-component

// https://www.htmlcsscolor.com/hex/197278   <- color names

const colors = {
  allPorts: '#197278',
  gableGreen: '#283d3b',
  sunGlow: '#FFD23F',
  goldenSand: '#e9c46a',
  grenadier: '#c44536',
  bittersweet: '#ff6b6b',
  radicalRed: '#ee4266',
  oldRose: '#BD3C51',
  bordeaux: '#580C1F',
  lusty: '#772e25',
  burntSienna: '#e76f51',
  potPourri: '#edddd4',
  ivory: '#FBFBF0',
  whisper: '#E5E5E5',
  snowDrift: '#e3e3d7',
  londonHue: '#A9A8A9',
  matterhorn: '#544C4B',
  buccaneer: '#664C4C',
  blackPearl: '#1E272C',
  oxfordBlue: '#263238',
  sanJuan: '#40555E',
  cyprus: '#104A4E',
  caputMotuum: '#4C1B15',
  thatch: '#A29896',
  opium: '#9D7B7B',
  pinkSwan: '#B2B2B2',
  oldLavender: '#767576',
  transparent: 'rgba(0,0,0,0)',
};
const switchMode = (isDarkMode, light, dark) => (isDarkMode === 1 ? dark : light);

export const Theme = (isDarkMode) => ({
  colors,
  effects: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.08)',
  },
  main: {
    // Site globals
    primaryHeader: switchMode(isDarkMode, colors.allPorts, colors.blackPearl),
    body: switchMode(isDarkMode, colors.whisper, colors.oxfordBlue),

    // Buttons
    buttonDefault: colors.gableGreen,
    buttonPlus: switchMode(isDarkMode, colors.allPorts, colors.cyprus),
    buttonPause: colors.gableGreen,
    buttonClose: colors.lusty,
    buttonPlay: colors.gableGreen,

    // Toggles
    togglePassive: colors.allPorts,
    toggleActive: colors.lusty,

    // Icons
    iconDefault: switchMode(isDarkMode, colors.ivory, colors.londonHue),

    // Notes
    noteHeaderActive: switchMode(isDarkMode, colors.grenadier, colors.caputMotuum),
    noteHeaderPassive: switchMode(isDarkMode, colors.allPorts, colors.blackPearl),

    // Text
    textarea: switchMode(isDarkMode, colors.ivory, colors.sanJuan),
    fontColor: switchMode(isDarkMode, colors.matterhorn, colors.thatch),
    largeTimer: switchMode(isDarkMode, colors.buccaneer, colors.opium),
    smallTimer: switchMode(isDarkMode, colors.whisper, colors.pinkSwan),
    placeholderText: switchMode(isDarkMode, colors.londonHue, colors.oldLavender),
    text: switchMode(isDarkMode, colors.ivory, colors.sanJuan),
    textDarker: colors.snowDrift,
  },

  media: {
    // Media Queries
    xs: '575.98px',
    sm: '767.98px',
    md: '991.98px',
    lg: '1199.98px',
  },
});

// const fontFace = (fontFamily, url, weight) => css`
// @font-face
//     font-family: '${fontFamily}';
//     src: url('${url}.eot');
//     src: url('${url}.eot?#iefix') format('embedded-opentype'),
//     url('${url}.woff') format('woff'),
//     url('${url}.ttf') format('truetype'),
//     url('${url}.svg') format('svg');
//     font-weight: ${weight};
//     font-style: normal;
// `;

export const opacifyOnHover = (opacity) => css`
background-color: rgba(0,0,0,0);
  &:hover{
    background-color: rgba(0,0,0, ${opacity}) ;
  }
`;
export const colorize = (color) => css`
background-color: ${color};
  &:hover{
    background-color: ${darken(0.1, color)};
  }
`;
// https://www.smashingmagazine.com/2013/02/setting-weights-and-styles-at-font-face-declaration/
// https://github.com/styled-components/styled-components/issues/1593
export const GlobalStyle = createGlobalStyle`
    ${normalize()}
   body{
     background: ${(props) => props.theme.main.body};
     width: 100%;
   }
   strong{
      font-family: 'Roboto', sans-serif;
      font-weight: normal;
   }
`;

// problematic font mixin, slows everything down
// https://github.com/styled-components/styled-components/issues/1593

// export const GlobalFonts = createGlobalStyle`
//    ${fontFaceFamilies};
// `;

// ${fontFace('Roboto', `${fontPath}/roboto/roboto-v19-latin-300`, 300)};
// ${fontFace('Roboto', `${fontPath}/roboto/roboto-v19-latin-regular`, 'normal')};
// export { GlobalStyle, memo(Theme), colorize };
